import type { ReactNode } from "react";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionHeading({ title, subtitle, icon, action }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="w-10 h-10 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
            <i className={`${icon} text-xl`} />
          </span>
        )}
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>
          )}
        </div>
      </div>
      {action}
    </div>
  );
}